const getCategoryReducer = (state = {}, action = {}) => {
    if (action.type === 'GET_EXAM') {
        return action.payload;
    }
    return state;
}

export default getCategoryReducer;
